export default "__VITE_ASSET__CU26IuL0__"